// Device types offered in the device selectors, in display order.
export const DEVICE_TYPE_OPTIONS = [
  "FOP",
  "PSL",
  "AIM",
  "INSTAREF",
  "INSTAZ",
  "INSTAZM",
  "PRISTINE",
  "OBM",
  "INSTAKC",
  "NEUBO",
  "OTHER"
];

const LAST_DEVICE_TYPE_KEY = "lastDeviceType";

/**
 * The device the user last picked, shared across pages and persisted across
 * sessions (localStorage) so the dashboard opens on the device they actually
 * use instead of always defaulting to FOP.
 */
export function getRememberedDeviceType() {
  const stored = localStorage.getItem(LAST_DEVICE_TYPE_KEY);
  return DEVICE_TYPE_OPTIONS.includes(stored) ? stored : "FOP";
}

export function rememberDeviceType(deviceType) {
  if (DEVICE_TYPE_OPTIONS.includes(deviceType)) {
    localStorage.setItem(LAST_DEVICE_TYPE_KEY, deviceType);
  }
}
